/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionDefinitionVersionBatchResponse {
    getFixupPrototypeFunction() { return DimensionDefinitionVersionBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<DimensionDefinitionVersionBatchResponse>): DimensionDefinitionVersionBatchResponse {
        let obj = Object.assign(new DimensionDefinitionVersionBatchResponse(), model);
        DimensionDefinitionVersionBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionDefinitionVersionBatchResponse>): DimensionDefinitionVersionBatchResponse {
        if (!model) return null;
        return DimensionDefinitionVersionBatchResponse.newInstance(<DimensionDefinitionVersionBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionDefinitionVersionBatchResponse) {
        if (!obj) return;

        models.DimensionDefinitionVersionBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionDefinitionVersionBatchResponse): boolean {
        Object.setPrototypeOf(obj, DimensionDefinitionVersionBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.DimensionDefinitionVersion.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.DimensionDefinitionVersion; };

}
